var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWave1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 350",
    width: 900,
    height: 350,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 157L12.5 164C25 171 50 185 75 181C100 177 125 155 150 143.7C175 132.3 200 131.7 225 133.7C250 135.7 275 140.3 300 155.5C325 170.7 350 196.3 375 204.2C400 212 425 202 450 187.2C475 172.3 500 152.7 525 151.3C550 150 575 167 600 182.3C625 197.7 650 211.3 675 207.3C700 203.3 725 181.7 750 176C775 170.3 800 180.7 825 191C850 201.3 875 211.7 887.5 216.8L900 222L900 351L887.5 351C875 351 850 351 825 351C800 351 775 351 750 351C725 351 700 351 675 351C650 351 625 351 600 351C575 351 550 351 525 351C500 351 475 351 450 351C425 351 400 351 375 351C350 351 325 351 300 351C275 351 250 351 225 351C200 351 175 351 150 351C125 351 100 351 75 351C50 351 25 351 12.5 351L0 351Z",
    fill: "#b8d1df",
    strokeLinecap: "round",
    strokeLinejoin: "miter"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave1);
export default __webpack_public_path__ + "static/media/wave-1.51d71d5a71ed7cd8b5076ec323dd717d.svg";
export { ForwardRef as ReactComponent };